<template>
<section class="row"  style="font-size: 13px">
	<div class="col-2" style=""></div>{{ contract }}
	<div class="col-8" style="font-size: 13px;">
        <div class="row">
			<div class="col-6">
				<div class='col-3'></div>
				<div class='col-9'>
					<img src="http://95.183.8.45/img/iconresh.png" class='img-responsive'>  
				</div>
			</div>
			<div class='col-6' style="padding: 20px;text-align:left">
				г. Пермь, Комсомольский проспект, 34, офис 310<br>
				Телефон: +7(342)299-42-79, 215-05-86, 250-92-50<br>
				E-mail: info@sr-sert.ru<br>
				Сайт: www.sr-sert.ru<br>
			</div>
		</div> 
		<hr>  
		<div  class="col-12 text-center paragraf">Договор № </div>  
		<div class='row'>
				<div class="col-4  text-left"  style="font-size:13px">г. Пермь</div>
				<div class="col-4"></div>
				<div class="col-4 text-right"  style="font-size:13px"> от </div>
		</div>
		<div class="row" style="margin-top:20px;font-size:13px">
				<p>именуемое в дальнейшем ЗАКАЗЧИК, в лице   , 
				действующего на основании   ,
				с одной стороны и ООО «ЦС Современные решения»  в лице Директора
				Филимоновой Юлии Владимировны, действующей на основании Устава,
				с другой стороны, совместно именуемые в дальнейшем СТОРОНЫ,
				заключили настоящий Договор о нижеследующем:</p>
		</div>

        <div class="col-12 text-center paragraf">1. ПРЕДМЕТ ДОГОВОРА</div>
		<div class="col-12 text-left " style="margin-top:20px; ">
			<p>1.1.	ЗАКАЗЧИК поручает, а ИСПОЛНИТЕЛЬ принимает 
				на себя обязательства по организации выполнения
				комплекса работ и услуг, связанных с получением 
				сертификатов/деклараций и иной разрешительной документации.</p> 
			<p>1.2.	Проведение работ, включает в себя:</p>
				<p style="margin-left:20px;">1.2.1.	Прием и регистрацию заявок/заявлений.</p>
				<p style="margin-left:20px;">1.2.2.	Консультирование ЗАКАЗЧИКА по вопросу 
					формирования комплекта документов, необходимого 
					для проведения сертификации/декларирования и 
					получением иной разрешительной документации.</p>
				<p style="margin-left:20px;">1.2.3.  Анализ предоставленной технической документации.</p>
				<p style="margin-left:20px;">1.2.4. Формирование на основании документов, полученных от ЗАКАЗЧИКА,
					комплектов документов, необходимых для получения сертификатов/деклараций
					и иной разрешительной документации. </p>
				<p style="margin-left:20px;">1.2.5. Представление в соответствующих организациях и 
					службах интересов ЗАКАЗЧИКА, связанных с получением 
					сертификатов/деклараций и иной разрешительной документации.</p>
				<p style="margin-left:20px;">1.2.6. Осуществление других мероприятий и функций, 
					связанных с исполнением обязательств по данному договору.</p>
				
		</div>		
		<div class="col-12 text-center paragraf" >2. ПРАВА И ОБЯЗАННОСТИ СТОРОН</div>
		<div class="col-12 text-left " style="margin-top:20px;">
			<p>2.1.	ИСПОЛНИТЕЛЬ обязуется:</p>
				<p style="margin-left:20px;">
					2.1.1.	Выполнить работы ЗАКАЗЧИКУ в соответствии с п. 1.1. и п. 1.2. 
					настоящего Договора. Cрок выполнения ИСПОЛНИТЕЛЕМ работ указан 
					в Спецификации (Приложение № 1 к Договору № </p>
			<p>2.2.	ИСПОЛНИТЕЛЬ вправе:</p>
				<p style="margin-left:20px;">
					2.2.1.	Потребовать от ЗАКАЗЧИКА устранить зависящие от него обстоятельства, 
					препятствующие выполнению Договора.</p>		
				<p style="margin-left:20px;">
					2.2.2.	Выполнять работы по Договору как лично, так и 
					с привлечением сторонних лиц и организаций.</p>	
			<p>2.3.	ЗАКАЗЧИК обязуется:</p>
				<p style="margin-left:20px;">
					2.3.1.	В полном объеме и своевременно оплачивать работы ИСПОЛНИТЕЛЯ.</p>		
				<p style="margin-left:20px;">
					2.3.2.	Устранить зависящие от него обстоятельства, препятствующие
					выполнению Договора.</p>	
			<p>2.4.	ЗАКАЗЧИК вправе:</p>
				<p style="margin-left:20px;">
					2.4.1.	Получать информацию о ходе выполнения Договора, контролировать ход его выполнения.</p>		
				<p style="margin-left:20px;">
					2.4.2.	Потребовать от ИСПОЛНИТЕЛЯ устранить зависящие от него
					обстоятельства, препятствующие выполнению Договора.</p>			
		</div>
			
		<div class="col-12 text-center paragraf" >3. СТОИМОСТЬ РАБОТ И ПОРЯДОК РАСЧЕТОВ</div>
		<div class="col-12 text-left " style="margin-top:20px;">
			<p>3.1.	Стоимость выполняемых работ определяется в Спецификации .</p>
			<p> 3.2.      В стоимость услуг по настоящему договору, указанную в п. 3.1.
				настоящего договора, включены расходы по оплате соответствующих пошлин и 
				сборов, необходимых для получения результата работ, а также иные затраты 
				ИСПОЛНИТЕЛЯ на выполнение обязательств по настоящему договору, включая стоимость
				услуг привлеченных третьих лиц</p>
			<p>3.3. За выполнение работ ЗАКАЗЧИК уплачивает ИСПОЛНИТЕЛЮ согласно выставленному счету
				(счетам) в соответствии со Спецификацией 
			.</p>
			<p>3.4. Оплата по Договору производится по безналичной системе расчетов. Моментом оплаты
				является дата поступления безналичных денежных средств на расчетный счет ИСПОЛНИТЕЛЯ.</p>
			<p>3.5.	Расчеты по настоящему договору осуществляются путем перечисления 
				денежных средств в размере суммы указанной в Спецификации.</p>
			<p>3.6.	ЗАКАЗЧИК считается исполнившим денежное обязательство по Договору с момента
				поступления денежных средств на расчетный счет ИСПОЛНИТЕЛЯ.</p>		
		</div>

		<div class="col-12 text-center paragraf">4. ПОРЯДОК СДАЧИ И ПРИЕМКИ</div>
		<div class="col-12 text-left " style="margin-top:20px;">
                <p>4.1.	После проведения работ по настоящему Договору СТОРОНЫ в течение 5 (пяти) 
                    рабочих дней подписывают двухсторонний Акт сдачи-приемки.</p>
				<p> 4.2.	В том случае, если после проведения работ по Договору 
					ИСПОЛНИТЕЛЬ составил и передал ЗАКАЗЧИКУ Акт сдачи-приемки, 
					а ЗАКАЗЧИК по истечении 5 (пяти) рабочих дней не подписал Акт 
					сдачи-приемки и не предъявил мотивированных претензий ИСПОЛНИТЕЛЮ 
					в письменной форме, то такие работы признаются СТОРОНАМИ выполненными 
					надлежащим образом, в полном объеме и в срок.</p>		
		</div>

		<div class="col-12 text-center paragraf">5. ОТВЕТСТВЕННОСТЬ СТОРОН</div>
		<div class="row"  style="margin-top:20px;">
		<p>5.1.	При нарушении ЗАКАЗЧИКОМ сроков исполнения обязательств, указанных 
			в Спецификации  , окончание работ по Договору переносится на время задержки.</p>
			<p> 5.2.	В случае нарушения срока окончания работ 
			ИСПОЛНИТЕЛЬ уплачивает ЗАКАЗЧИКУ неустойку в виде пени 
			в размере 0,1% от общей стоимости работ за каждый рабочий 
			день просрочки от общей стоимости работ.</p>	
			<p> 5.3.	ИСПОЛНИТЕЛЬ не несет ответственности за 
			коммерческий и предпринимательский риск ЗАКАЗЧИКА.</p>	
			<p> 5.4.	В случае досрочного расторжения договора по инициативе 
			ЗАКАЗЧИКА, ЗАКАЗЧИК выплачивает ИСПОЛНИТЕЛЮ стоимость
			фактически выполненной работы.</p>	
			<p> 5.5.	ИСПОЛНИТЕЛЬ не несет ответственность за достоверность и 
			легитимность оригиналов и копий документов, полученных от ЗАКАЗЧИКА.</p>		
		</div>
            
		<div class="col-12 text-center paragraf">6. ФОРС-МАЖОР</div>
		<div class="col-12 text-left " style="margin-top:20px;">
			<p>6.1.СТОРОНЫ полностью освобождаются от ответственности
			за частичное или полное неисполнение обязательств по настоящему 
			Договору, если это неисполнение явилось следствием действия 
			обстоятельств непреодолимой силы, возникших после заключения настоящего
			Договора в результате событий чрезвычайного характера, которые Стороны 
			не могли предвидеть, избежать или предотвратить.Под обстоятельствами непреодолимой 
			силы Стороны понимают пожар, землетрясения, наводнения, 
			тайфун, ураган и других стихийные бедствия, войны и военных
			действий любого характера, гражданские волнения, блокады, запрет 
			экспорта или импорта (эмбарго), акты органов государственной власти
			, местного самоуправления, международных организаций и союзов, 
			а также обстоятельства, возникшие вследствие применения государственными 
			и/или надгосударственными органами и/или международными организациями 
			и союзами, включая руководящие органы Европейского союза, ограничительных
			и/или запретительных мер (санкций) в отношении Российской Федерации и/или 
			ее резидентов (физических и юридических лиц), не позволяющих какой-либо
			из Сторон исполнить свои обязательства по настоящему Договору, в том числе,
			но не ограничиваясь, невозможность произвести платеж в любой валюте 
			по настоящему Договору,  отказ в обслуживании международными 
			банками-корреспондентами, блокировка счетов, в том числе в иностранной валюте.
			</p>
			<p>6.2.	СТОРОНА, в отношении которой произошли указанные обстоятельства, 
			обязана не позднее 10 (десяти) дней с момента их наступления в письменном 
			виде уведомить другую Сторону об их наступлении с приложением документа из 
			компетентного государственного органа, подтверждающего наступление указанных 
			обстоятельств. В случае не уведомления о наступлении обстоятельств непреодолимой 
			силы указанные обстоятельства не принимаются другой Стороной во внимание, 
			и Стороны не освобождаются от ответственности за неисполнение своих обязательств
			по настоящему Договору. В случае если обстоятельства непреодолимой 
			силы будут действовать более трех месяцев, настоящий Договор признается
			прекратившим свое действие по инициативе одной из сторон по истечении 
			трех месяцев с момента получения уведомления об их наступлении.
			</p>		
		</div>

		<div class="col-12 text-center paragraf">7. ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ</div>
		<div class="col-12 text-left "  style="margin-top:20px;">
			<p>7.1.	Все споры, возникающие в процессе исполнения настоящего
			Договора, которые не были урегулированы путем переговоров, 
			подлежат рассмотрению в Арбитражном суде Пермского края  в
			соответствии с действующим законодательством Российской Федерации.</p>	
		</div>
            
		<div class="col-12 text-center paragraf">8. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</div>
		<div class="col-12 text-left "  style="margin-top:20px;">
			<p>8.1.	Настоящий Договор вступает в силу с момента его 
			подписания и действует до полного исполнения СТОРОНАМИ 
			взятых на себя обязательств и завершения всех взаиморасчетов между ними.</p>	
			<p>8.2.	Настоящий Договор составлен в двух подлинных экземплярах,
			имеющих одинаковую юридическую силу,
			по одному для каждой из СТОРОН.</p>	
			<p>8.3.	Любые изменения и дополнения к настоящему Договору действительны 
			при условии, если они составлены в письменной форме и подписаны уполномоченными 
			представителями обеих СТОРОН.</p>	
		</div>
        
		<div class="col-12 text-center paragraf">9. АДРЕСА И РЕКВИЗИТЫ СТОРОН</div>
		<div class="row"  style="margin-top:20px;">
			<div class='col-5 ' style="margin-top:20px;">	
					<div class="col-12 text-center" style="font-size: 24px">ИСПОЛНИТЕЛЬ:</div>
					<p>ООО «ЦС Современные решения»</p>
					<p>Юридический  адрес: 614000, Пермский край,
					г. Пермь, ул. Вагонная 29</p>
					<p>Фактический адрес: 614000, Пермский край, 
					г. Пермь, Комсомольский проспект, 34, оф. 310, </p>
					<p>тел. 8(342) 219-61-50</p>
					<p>ИНН 5903999600 КПП 590301001</p>
					<p>р/с 40702810129490001886 в ОО «Малахит» Филиала «Нижегородский» ОАО «АЛЬФА-БАНК»</p>
					<p>БИК 042202824</p>
					<p>к/с 30101810200000000824</p>
					<p>ОГРН  1027700132195</p>
			</div>
			<div class="col-2" ></div>
			<div class="col-5 text-center" style="margin-top:20px;">	
				<div class="col-12 text-center" style="font-size: 24px">ЗАКАЗЧИК:</div>
				<p>  </p>
				<p>Юридический  адрес:   </p> 
				<p>Фактический адрес:  </p>
				<p>тел.   </p> 
				<p>ИНН  КПП  </p>
				<p>р/с    в  </p>
				<p>БИК  </p>
				<p>к/с   </p>
				<p>ОГРН    </p>
			</div>
		</div>
				
        <div class="row" style="margin-top:20px;">
			<div class='col-12 text-center paragraf'>10. ПОДПИСИ СТОРОН</div>

			<div class='col-5' style="margin-top:20px;">	
				<p>От имени ИСПОЛНИТЕЛЯ:</p>
				
					<div class="col-xs-6"><img class="img-responsive" src="http://95.183.8.45/img/stamp.png" style="height: 120px"></div>
					<p style="margin-top:150px;">   Ю.В. Филимонова</p>	
					<p style="margin-top:150px;">___________________Ю.В. Филимонова</p>	
				
			</div>	
			<div class='col-xs-5' style="margin-top:20px;">	
				
				<p>От имени ЗАКАЗЧИКА:</p>
				
				<p> ___________________</p>	
				<p> м.п.</p>
			</div>	
		</div>

			<div class="row justify-content-end" style="margin-top:20px;">
				<div class='col-4 text-right' style="margin-top:20px;">	
					<p>Приложение № 1</p>
					<p> к Договору №   ></p>
					<p>от   .г</p>
				</div>	
			</div>

			<div class='col-12 text-center paragraf' style="margin-top:80px;">СПЕЦИФИКАЦИЯ №1</div>	
			<div class="row" style="margin-top:80px;">
				<p>Мы, нижеподписавшиеся, от лица ЗАКАЗЧИКА 
				Директор  
				, действующий на основании  , 
				от лица ИСПОЛНИТЕЛЯ Директор ООО ЦС «Современные решения».
				Филимоновой Ю.В., действующей на основании Устава, удостоверяем, 
				что СТОРОНАМИ достигнуто соглашение о величине договорной цены на проведение работ:</p>
			</div>
			<div class='row' style="margin-top:20px;">
				<table class="table table-bordered">
					<tr>
						<th>№</th>
						<th>Наименование продукции/Документ</th>
						<th>Кол-во</th>
						<th>Стоимость с НДС</th>
						<th>Инспекционный контроль</th>
						<th>Сроки оформления в днях</th>
					</tr>
					<tr>
						<td>  </td>
						<td>Оформление   
						на продукцию: .
						С выдачей протокола испытаний</td>
						<td>  </td>
						<td>  </td>
						<td>Инспекционный контроль включен</td>";
						<td>Инспекционный контроль не включен</td>";
						<td>  </td>
					</tr>
					<tr>
						<td colspan="3"><b>Итого: </b></td>
						<td ><b>  </b></td>
						<td ><b></b></td>
						<td ><b>  </b></td>
					</tr>
				</table> 
			</div>
			<div class='row' style="margin-top:20px;">
				С выдачей протокола испытаний (   шт)";
			</div>
			<div class='row' style="margin-top:20px;">
			</div>
			<div class='row' style="margin-top:20px;">
				<p>Настоящее Приложение является основанием для проведения взаимных 
				расчетов и платежей между ИСПОЛНИТЕЛЕМ и ЗАКАЗЧИКОМ.</p>
				<p>Настоящее Приложение составлено в двух подлинных экземплярах,
				имеющих одинаковую юридическую силу, по одному для каждой из СТОРОН,
				и является неотъемлемой частью Договора  №   г. </p>
			</div>

		<div class='row' style="margin-top:20px;">
		<div class='col-xs-5' style="margin-top:20px;">	
				<p>От имени ИСПОЛНИТЕЛЯ:</p>
				<div class="col-xs-6"><img class="img-responsive" src="http://95.183.8.45/img/stamp.png" style="height: 80px"></div>
				<p style="margin-top:150px;">   Ю.В. Филимонова</p>	
				<p style="margin-top:150px;">___________________Ю.В. Филимонова</p>	
			</div>	
			<div class='col-xs-5' style="margin-top:20px;">	
				<p>От имени ЗАКАЗЧИКА:</p>
				<p style="margin-top:150px;"> ___________________   </p>	
			</div>	
		</div>
	
	
	</div>	
	<div class="col-2" style=""></div>
	
</section>		
</template>
<script>
  import Acl from '../../utils/acl'
  import Vuex from 'vuex'
  import Http from '../../utils/http'


  export default {
    mixins: [Acl],
    name: 'printContract',
    data () {
      return {
		contract: null,
        id: this.$route.params.id
      }
    },
    components: {

    },
    computed: {
      ...Vuex.mapGetters({
          apiUrl: 'app/apiUrl',
          datalist: 'clients/datalist',
          pagination: 'clients/pagination',
      }),
    },
    methods: {
      ...Vuex.mapMutations({
          setMessage: 'app/setMessage',
          setError: 'app/setError',
          setHeader:'app/setCurrentPageHeader'
      }),
      ...Vuex.mapActions({
          save: 'outcall/save',
          find: 'clients/find',
          drop: 'outcall/delete',
      }),
      getContract() {
        Http.get(this.apiUrl + '/contracts?id=' + this.id)
          .then((response) => {
			console.log(response)  
            this.contract = response.data[0]
          })
      },
    },
    created() {
      this.getContract()
    }
  }
</script>
<style scoped>

.paragraf{
	font-size:23px
}
p{
	font-size: 11px;
}

</style>